import {z as zod} from "zod";

export type AnankePreferences = {
    theme: "light" | "dark";
    // isMobileSidebarCollapsed: boolean;
    isDesktopSidebarCollapsed: boolean;
};

export const anankePreferencesZodValidator = zod.object({
    theme: zod.enum(["light", "dark"]),
    // isMobileSidebarCollapsed: zod.boolean(),
    isDesktopSidebarCollapsed: zod.boolean(),
});

export const defaultAnankePreferences: AnankePreferences = {
    theme: "light",
    // isMobileSidebarCollapsed: false,
    isDesktopSidebarCollapsed: false,
};
